
import React , {useEffect } from 'react'; 
import app from "./app" 
import {GridWrap, ListWrap, Elements} from "./helpers" 
 

export const VideoOne = function(props) { 
    const {data, index, widgetType, mode, device} = props; 
    let listitem = "" 
    if(data.elements.videoList){
         if(data.elements.videoList.items){
            listitem = data.elements.videoList.items.map(function(v, i){
                return <GridWrap className="mt-1 overflow-hidden" data={v} key={'key-' + v.viewId + i} id="videoList" mode={mode} device={device}>
                     <Elements row={v.video} id={"video"} device={device} mode={mode}/> 
                    <Elements row={v.heading} id={"heading"} device={device} mode={mode}/> 
                    <Elements row={v.summary} id={"summary"} device={device} mode={mode}/>   
                    <div style={device === "desktop"?{margin:app.elementPadding(v.properties.marginWeb)}:{margin:app.elementPadding(v.properties.margin)}}>
                        <Elements row={v.primaryButton} id={"primaryButton"} device={device} mode={mode}/>  
                    </div> 
                </GridWrap> 
            }) 
        } 
        listitem = <ListWrap data={data.elements.videoList} className={'align-items-stretch g-4'} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

return  <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode}/>
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode}/>  
            </div>
        </div>
        {listitem} 
    </div>
}

export const VideoTwo = function(props) { 
    const {data, index, widgetType, mode, device} = props; 
    let listitem = "" 
    if(data.elements.videoList){ 
         if(data.elements.videoList.items){   
            listitem = data.elements.videoList.items.map(function(v, i){  
                 return <GridWrap swiper={data.elements.videoList.properties.isSwiper} className="mt-1 overflow-hidden" data={v} key={'key-' + v.viewId + i} id="videoList" mode={mode} device={device}>
                    <div className={v.properties.isFlipped?`row flex-row-reverse m-0`:`row m-0`}> 
                        <div className={!v.heading.properties.showWeb && !v.summary.properties.showWeb && !v.primaryButton.properties.showWeb || !v.heading.properties.show && !v.summary.properties.show && !v.primaryButton.properties.show? `col-12 col-md-12 px-0` : `col-12 col-md-5 px-0`}>
                            <Elements row={v.video} id={"video"} device={device} mode={mode}/> 
                        </div> 
                        <div className={!v.video.properties.showWeb || !v.video.properties.show? `col-12 col-md-12 px-0 d-flex align-items-center` : `col-12 col-md-7 px-0 d-flex align-items-center`}>
                            <div className="card-body p-0 p-lg-0"> 
                                <Elements row={v.heading} id={"heading"} device={device} mode={mode}/> 
                                <Elements row={v.summary} id={"summary"} device={device} mode={mode}/>   
                                <div style={device === "desktop"?{margin:app.elementPadding(v.properties.marginWeb)}:{margin:app.elementPadding(v.properties.margin)}}>
                                    <Elements row={v.primaryButton} id={"primaryButton"} device={device} mode={mode}/>  
                                </div>
                                
                            </div>
                        </div>
                    </div> 
                </GridWrap> 
            }) 
        } 
        listitem = <ListWrap data={data.elements.videoList} className={'align-items-stretch g-4'} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

return  <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode}/>
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode}/>  
            </div>
        </div>
        {listitem} 
    </div>
}
  